import { IssueFieldNames } from 'shared/domain/issueForm/types/fieldNames';
import { availableFieldLabelKey } from 'intl';
import { FieldConfig } from './types';

function getFieldConfig(fieldName: IssueFieldNames): FieldConfig {
  return {
    fieldName,
    labelId: availableFieldLabelKey(fieldName),
  };
}

export const WORK_TYPE_FIELD = getFieldConfig(IssueFieldNames.workTypes);
export const ROOT_CAUSE_FIELD = getFieldConfig(IssueFieldNames.rootCauses);
export const HAZARD_CATEGORY_FIELD = getFieldConfig(
  IssueFieldNames.hazardCategory
);
export const ENVIRONMENTAL_ASPECT_FIELD = getFieldConfig(
  IssueFieldNames.environmentalAspect
);
export const CORRECTIVE_ACTION_TYPE_FIELD = getFieldConfig(
  IssueFieldNames.proposedCorrectiveAction
);
export const DELAY_REASON_FIELD = getFieldConfig(
  IssueFieldNames.delayReason
);
export const ISSUE_VERIFICATION_FIELD = getFieldConfig(
  IssueFieldNames.issueVerification
);
export const REJECTION_REASON_FIELD = getFieldConfig(
  IssueFieldNames.rejectionReason
);
export const EFFECT_FIELD = getFieldConfig(IssueFieldNames.effect);
export const IMPACT_FIELD = getFieldConfig(IssueFieldNames.impact);
export const PRIORITY_FIELD = getFieldConfig(IssueFieldNames.priority);
export const PROJECT_STAGE_FIELD = getFieldConfig(IssueFieldNames.projectStage);
export const DECISION_TO_IMPOSE_FINE_FIELD = getFieldConfig(
  IssueFieldNames.decisionToImposeFine
);
export const CIRCUMSTANCES_FIELD = getFieldConfig(
  IssueFieldNames.circumstances
);
export const SPILLED_SUBSTANCE_FIELD = getFieldConfig(
  IssueFieldNames.spilledSubstance
);
export const EMPLOYMENT_TYPE_FIELD = getFieldConfig(
  IssueFieldNames.employmentType
);
export const INJURY_TYPES_FIELD = getFieldConfig(
  IssueFieldNames.injuryTypes
);
export const INJURED_BODY_PARTS_FIELD = getFieldConfig(
  IssueFieldNames.injuredBodyParts
);
export const REQUIREMENTS_FIELD = getFieldConfig(
  IssueFieldNames.requirements
);
export const INSTALLATION_BASIS_FIELD = getFieldConfig(
  IssueFieldNames.installationBasis
);
export const CONSTRUCTION_PRODUCT_DOCUMENTS_FIELD = getFieldConfig(
  IssueFieldNames.constructionProductDocuments
);
export const DEVICE_DOCUMENTS_FIELD = getFieldConfig(
  IssueFieldNames.deviceDocuments
);
export const ADDITIONAL_DOCUMENTS_FIELD = getFieldConfig(
  IssueFieldNames.additionalDocuments
);
